import React from 'react';
import NewMenu from './new-menu';

const Menu = () => {
  return (
    <NewMenu />
  )
};

export default Menu;
